import type { NodeProps } from '@xyflow/react';
import { memo } from 'react';

import { TaxChartNode } from '../../TaxDiagram/components/TaxChartNode';
import type { StructureEntityFlowNode } from '../canvas';

// The tax chart's shape, popover and Change shape, placed by the structure chart's layout.
const TaxStructureEntityNode = memo(function TaxStructureEntityNode({
  id,
  data,
}: NodeProps<StructureEntityFlowNode>) {
  return <TaxChartNode id={id} data={data.entity.source} />;
});

export { TaxStructureEntityNode };
